module.exports = __webpack_public_path__ + "static/media/survey-file-icon.16cf1e4b.svg";